module.exports = __webpack_public_path__ + "img/kapcsolat_background-768.d693791a.png";